<script>
import { mapGetters } from 'vuex';

export default {
    name: 'QuestionCard',
    props: {
        title: String,
        categories: Array,
        slug: String,
    },
    methods: {
        getCategorySlug(categoryId) {
            const category = this.allCategories.find(item => item.id === categoryId);
            return category ? category.slug : null;
        },
    },
    computed: {
        ...mapGetters({
            allCategories: 'getAllQuestionCategories',
        }),
        baseUrl() {
            return this.$route.path.split('/')[1]
        }
    },
};
</script>

<template>
    <article class="question-card">
        <div class="question-card__background"></div>
        <router-link v-bind:to="'/' + baseUrl + '/' + this.slug" class="question-card__wrapper">
            <div class="question-card__inner">
                <header class="question-card__header">
                    <h1 class="question-card__title">{{ title }}</h1>
                    <ul class="question-card__categories categories" v-if="categories.length > 0"> 
                        <li class="question-card__category category" 
                            v-for="(category, i) in categories" 
                            v-bind:key="i" 
                            v-bind:class="['category--' + getCategorySlug(category)]">
                        </li>
                    </ul>
                </header>
                <footer class="question-card__footer">
                    <span class="question-card__link read-more">
                        {{ $t('questionCard.linkLabel') }}
                    </span>
                </footer>
            </div>
        </router-link>
    </article>
</template>

<style lang="scss" scoped>
.question-card {
    position: relative;
}
.question-card__background {
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
    background: rgba($color-card-background, .8);
    transition: transform 750ms cubic-bezier(0.19, 1, 0.22, 1);
}
.question-card:hover .question-card__background {
    @include breakpoint('md-up') {
        transform: scale(1.045);
    }
}
.question-card__wrapper {
    text-decoration: none;
}
.question-card__inner {
    position: relative;
    height: 21.6rem;
    box-sizing: border-box;
    padding: 2.2rem 4rem;
    
    
    @include breakpoint('xs') {
        padding: 1.6rem 2.56rem;
    }
}
.question-card__header {
    height: 14.72rem;

    @include breakpoint('xs') {
        height: 16.32rem;
    }
}
.question-card__title {
    display: block; display: -webkit-box;
    height: 12rem;
    max-width: 32rem;
    margin: 0 2.4rem 0 0;
    font-size: 2.48rem;
    letter-spacing: .0286em;
    line-height: 1.2;
    font-weight: 300;
    color: $color-primary;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.question-card__categories {
    position: absolute;
    top: 2rem; right: 2rem;

    @include breakpoint('xs') {
        top: 1.6rem; right: 1.6rem;
    }
}
.question-card__category {
    transition: transform 450ms cubic-bezier(0.19, 1, 0.22, 1);
}
.question-card:hover .question-card__category {
    @include breakpoint('md-up') {
        transform: scale(1.3);
    }
}
</style>
